import type { SchemaPerspective } from 'types/schema';

/** Relations that wire a sphere into the tree; a perspective on one is structure, not membership. */
export const STRUCTURAL_RELATIONS: readonly string[] = ['parent', 'center'];

/**
 * A membership perspective is a merged-schema perspective someone can be assigned to: not dropped,
 * not hidden, and not on a structural relation.
 */
export function isMembershipPerspective(
  perspective: Pick<SchemaPerspective, 'permission_system_relation' | 'is_hidden' | 'dropped'>,
): boolean {
  return (
    !perspective.dropped &&
    !perspective.is_hidden &&
    !STRUCTURAL_RELATIONS.includes(perspective.permission_system_relation)
  );
}
